module.exports = __webpack_public_path__ + "img/dashboard-icon2.0562d0af.svg";